import { type ImgHTMLAttributes, useEffect, useRef, useState } from 'react'
import { SKELETON } from './Skeleton'

// Una foto que, mientras se descarga, se ve como un esqueleto del mismo tamaño (con mala
// cobertura tarda). Si ya estaba en caché, aparece directamente. Si falla, queda el fondo gris
// en vez del icono de imagen rota.
export const Photo = ({ className = '', onLoad, onError, ...props }: ImgHTMLAttributes<HTMLImageElement>) => {
	const ref = useRef<HTMLImageElement>(null)
	const [state, setState] = useState<'loading' | 'loaded' | 'failed'>('loading')

	// biome-ignore lint/correctness/useExhaustiveDependencies: hay que volver a esperar si cambia la foto
	useEffect(() => {
		setState(ref.current?.complete && ref.current.naturalWidth > 0 ? 'loaded' : 'loading')
	}, [props.src])

	return (
		// biome-ignore lint/a11y/useAltText: el texto alternativo llega en `props` (alt) desde quien la usa
		<img
			ref={ref}
			{...props}
			data-state={state}
			onLoad={(event) => {
				setState('loaded')
				onLoad?.(event)
			}}
			onError={(event) => {
				setState('failed')
				onError?.(event)
			}}
			className={`${className} ${state === 'loaded' ? '' : SKELETON} ${state === 'failed' ? 'text-transparent' : ''}`.trim()}
		/>
	)
}
